export default {
  GET_ALL_ENABLERS: 'getEnablers',
  SAVE_ENABLER: 'saveEnabler',
  UPDATE_ENABLER: 'updateEnabler',
  GET_ENABLERS_ATTACHED: 'getEnablersAttached',
  GET_ENABLERS_BY_NODE: 'getEnablersByNode',
  ADD_ENABLER_NODE_RELATIONSHIP: 'addEnablerNodeRelationship',
  REMOVE_ENABLER_NODE_RELATIONSHIP: 'removeEnablerNodeRelationship'
}
